import React from 'react';
import { GenericModal } from 'web-ui-components/lib/layout/content';

import { Content } from '../../infrastructure/content';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';

export const ExitModal = ({ saveEnabled, handleExit, isExitModalOpen, toggleModal, username }) => (
  <Content>
    {({
      exitAndSaveModalContentA,
      exitAndSaveModalContentB,
      exitAndSaveModalUsername,
      exitModalContent,
      exitModalTitle,
      exitModalConfirmButtonText,
      exitModalCancelButtonText
    }) => (
      <GenericModal
        titleText={exitModalTitle}
        onConfirm={handleExit}
        isOpen={isExitModalOpen}
        onClose={toggleModal}
        dismissButtonText={exitModalCancelButtonText}
        confirmButtonText={exitModalConfirmButtonText}
      >
        {!saveEnabled && <p>{exitModalContent}</p>}
        {saveEnabled && (
          <StandardBody>
            <p>{exitAndSaveModalContentA}</p>
            <StandoutTile.Remember>
              <p>{exitAndSaveModalContentB}</p>
              {username && (
                <p>
                  {exitAndSaveModalUsername}
                  <strong>{username}</strong>
                </p>
              )}
            </StandoutTile.Remember>
          </StandardBody>
        )}
      </GenericModal>
    )}
  </Content>
);
